export const API_PATH_START_DATASET_QA_WORK_SESSION = '/dataset-reviews/start-session';
export const API_PATH_END_DATASET_QA_WORK_SESSION = '/dataset-reviews/end-session';
export const API_PATH_DATASET_QA_ASSIGNED_TASK = '/dataset-reviews/task';
export const API_PATH_DATASET_QA_BY_ID = '/dataset-reviews/:id';
export const API_PATH_DATASET_QA_STATUS = '/dataset-reviews/status';
export const API_PATH_PRODUCT_DATASET_IMAGES_FIND = '/product-dataset-images/find';
export const API_PATH_PRODUCT_DATASET_IMAGE_VALIDATE = '/product-dataset-images/validate';
export const API_PATH_PRODUCT_DATASET_IMAGE_CLUSTERS_FIND = '/product-dataset-image-clusters/find';
export const API_PATH_PRODUCT_DATASET_IMAGE_CLUSTER_SIMILAR = '/product-dataset-image-clusters/:clusterId/similar';
export const API_PATH_PRODUCT_DATASET_IMAGE_CLUSTER_MARK_FOR_DELETION =
  '/product-dataset-image-clusters/:clusterId/mark-for-deletion';
export const API_PATH_PRODUCT_DATASET_IMAGE_CLUSTER_PRODUCT_VARIANT =
  '/product-dataset-image-clusters/:clusterId/product-variant/:variantId';

// ProductDatasetImageCluster is annotated @DefaultFields({"id"}) on the backend, so every cluster
// response collapses to {"id": n} unless the request asks for more. Always send these along.
export const CLUSTER_SELECT_FIELDS = 'id,productVariant.id';

// The cluster carries no cover image of its own — it lives on the image side, flagged by
// ProductDatasetImage.reference and linked back through ProductDatasetImage.cluster.
export const CLUSTER_IMAGE_SELECT_FIELDS = 'id,image.url,cluster.id';

// Counting needs every non-deleted image, not just the reference one, so image.url never travels
// here — only the two fields the client-side count actually groups by.
export const CLUSTER_IMAGE_COUNT_SELECT_FIELDS = 'id,cluster.id';

// On /similar the select doubles as the Hibernate entity graph, so a path left out is not merely
// omitted from the JSON, it is never loaded. No EAN: that lives on the product, not the variant, and
// would cost a second request on every anchor change.
export const SIMILAR_CLUSTER_SELECT_FIELDS = 'id,productVariant.id,productVariant.name,productVariant.image.url';

// Rows per request, not a ceiling: every cluster service reads every page. Clusters and reference
// images run roughly one row per cluster, so this resolves in a single round trip.
export const CLUSTERS_PAGE_SIZE = 200;
export const CLUSTER_REFERENCE_IMAGES_PAGE_SIZE = 500;
export const DELETED_CLUSTERS_PAGE_SIZE = 200;

// Generous on purpose: counting pulls every image of every cluster on screen, not just one row per
// cluster. A single page avoids pagination drift entirely (see countImagesByCluster's dedupe,
// which only catches the half of that drift that duplicates a row, not the half that skips one).
export const CLUSTER_IMAGE_COUNT_PAGE_SIZE = 2000;

// Small page on purpose: the reviewer asks for more.
export const CLUSTER_IMAGES_BROWSER_PAGE_SIZE = 24;

// One `cluster.id` goes in the query string per cluster, so an unbatched request line passes the
// 8 KB most gateways accept once a variant has a few hundred clusters.
export const CLUSTER_IDS_PER_REQUEST = 100;

// The backend default of 5 is a cap on clusters, not on variants, so those five can land on two or
// three variants by chance and hide candidates the reviewer should have seen. 20 spreads them out.
export const SIMILAR_CLUSTERS_LIMIT = 20;
export const DATASET_QA_STATUS_REFETCH_INTERVAL = 15_000; // 15 seconds
export const DATASET_QA_SESSION_STORAGE_KEY = 'datasetQaSessionActive';
export const DATASET_QA_TICKET_VALIDATION_STORAGE_KEY = 'datasetQaTicketValidationState';
export const DELETED_VARIANT_ID = -1;
// Longer validations are published capped at this and reported to Sentry.
export const DATASET_QA_WORK_SESSION_TTL_SECONDS = 15 * 60; // 15 minutes

export const QUERY_KEYS = {
  DATASET_QA_TASKS: 'dataset-qa-tasks',
  DATASET_QA_STATUS: 'dataset-qa-status',
  VARIANT_CLUSTERS: 'variant-clusters',
  CLUSTER_IMAGES: 'cluster-images',
  CLUSTER_IMAGE_COUNTS: 'cluster-image-counts',
  SIMILAR_CLUSTERS: 'similar-clusters',
  DELETED_CLUSTERS: 'deleted-clusters',
  CLUSTER_IMAGES_BROWSER: 'cluster-images-browser',
};
